import { Component, Input, ViewEncapsulation } from '@angular/core';
import { InfoConfirmComponent } from '../info-confirm/info-confirm.component';
import { MatDialogConfig } from '@angular/material/dialog';
import { TmModalData } from '../../entity/TmModalData';

@Component({
  selector: 'tm-info-alert',
  templateUrl: '../info-confirm/info-confirm.component.html',
  styleUrls: ['./info-alert.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class InfoAlertComponent extends InfoConfirmComponent {
  /** 表頭標題，預設為"INFO" */
  @Input() title = 'INFO';
  /** 確認按鈕標籤 */
  okBtnLabel = '';
  modalConfig: MatDialogConfig<TmModalData> = {role: 'alertdialog', hasBackdrop: false};
  /** 自訂義彈窗的 css 類，預設為"info-alert-modal" */
  @Input() panelClass: string[] = ['info-alert-modal'];
}
